// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3CSFc","buttons":"PendingPaymentAlert_buttons__bKZxv"};